import { ILabelProps, Label } from '@fluentui/react/lib/Label';

export interface IPLabelProps extends ILabelProps {}

export const IPLabel = (props: IPLabelProps) => {
  return <Label {...props} />;
};
